import { Space, Stack } from '@mantine/core';
import { Split } from 'components/Split';
import {
  ActivityInfoPanel,
  ContactPersonPanel,
  DebtorInfoPanel,
  DebtorNotes,
  DebtorTickersBanner,
} from './components';

export const InfoTabAtRisk = () => {
  return (
    <Stack mt="sm">
      <DebtorTickersBanner />
      <Split left={50} align="stretch">
        <DebtorInfoPanel withBorder />
        <ActivityInfoPanel />
      </Split>
      <DebtorNotes />
      <ContactPersonPanel />
      <Space h="md" />
    </Stack>
  );
};
